export const FormsSubject = {
    book_a_valuation_sell:{
        admin_subject:"New Vendor Enquiry",
        user_subject:"Your recent enquiry"
    },
    book_a_valuation_let:{
        admin_subject:"New Landlord Enquiry",
        user_subject:"Your recent enquiry"
    },
    book_a_viewing:{
        admin_subject:"Book a Viewing",
        user_subject:"Your viewing request"
    },
    contact_branch:{
        admin_subject:"Contact Branch",
        user_subject:"Contact Branch | Your recent enquiry"
    },
    contact_staff:{
        admin_subject:"Staff Contact",
        user_subject:"Staff Contact | Your recent enquiry"
    },
    get_in_touch:{
        admin_subject:"Contact",
        user_subject:"Your recent enquiry"
    },
    newsletter:{ 
        admin_subject:"Newsletter Subscription",
        user_subject:"Thank you for subscribing"
    },
    instant_valuation:{
        admin_subject:"Valuation Request",
        user_subject:"Your valuation request"
    },
    send_to_friend:{
        admin_subject:"Send to a friend",
        user_subject:"Send to a friend"
    },
    ask_question:{
        admin_subject:"Ask a Question",
        user_subject:"Your recent enquiry"
    },
    payments:{
        admin_subject:"Payments",
        user_subject:"Payments"
    },
    rent_home:{
        admin_subject:"Apply to Rent a Home",
        user_subject:"Apply to Rent a Home"
    },
    complaints:{
        admin_subject:"Complaints Submission",
        user_subject:"Complaints Submission"
    },
    bulk_enquiry:{
        admin_subject:"Bulk Enquiry",
        user_subject:"Bulk Enquiry"
    },
    confirm_requirements:{
        admin_subject:"Confirm Your Requirements",
        user_subject:"Confirm Your Requirements"
    },
    bv_discounts:{
        admin_subject:"BV Discounts",
        user_subject:"BV Discounts"
    },
    rent_student_home:{
        admin_subject:"Apply to Rent a Student Home",
        user_subject:"Apply to Rent a Student Home"
    },
    tenancy_offer:{
        admin_subject:"Tenancy Offer",
        user_subject:"Tenancy Offer"
    },
    register_interest:{
        admin_subject:"Register Interest",
        user_subject:"Register Interest"
    },
    contact_investment:{
        admin_subject:"Contact Investment Centre",
        user_subject:"Contact Investment Centre"
    }
}